import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { CoursePlayerState, stateContext } from './course-player.context';
import { consume } from '@lit/context';
import '../../shared/components/html-content/html-content';

@customElement('lua-course-player-description')
export class LuaCoursePlayerDescription extends LitElement {
  @consume({ context: stateContext })
  coursePlayerState: CoursePlayerState;

  protected override render() {
    const description = this.coursePlayerState.enrollment?.description;

    return html`<lua-html-content
      .content=${description}
      .useCkEditorStyles=${true}
      slot="content"></lua-html-content>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'lua-course-player-description': LuaCoursePlayerDescription;
  }
}
